export { default, links, meta } from "/Volumes/Files HD/Development/datos-remix/app/root.tsx";